import flag from '../../../assets/flag.svg'
import ch_flag from '../../../assets/ch_flag.svg'

export function WeekCardFlag({status, isDeadline}: {status: string | undefined, isDeadline: boolean}) {
    if (isDeadline) {
        return <img src={ch_flag} alt="ch_flag" className='w-4 h-4' />
    } else if (status !== "Completed") {
        return <img src={flag} alt="flag" className='w-4 h-4' />
    } else {
        return null
    }
}